import { BalanceRegistrationImpl } from "features/balanceRegistration/data/BalanceRegistrationImpl";
import { BalanceRegistrationViewModel } from "features/balanceRegistration/presentation/viewModel/BalanceRegistrationViewModel";
import { IBalanceRegistrationRepository } from "../domain/repositories/IBalanceRegistrationRepository";
import { BalanceRegistrationUseCase } from "../domain/useCases/BalanceRegistrationUseCase";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class BalanceRegistrationInjection extends InjectionModule {
  private static readonly balanceRegistrationRepositoryToken = Symbol(
    "IBalanceRegistrationRepository",
  );
  private static readonly balanceRegistrationViewModelToken = Symbol(
    "BalanceRegistrationViewModel",
  );
  private static readonly balanceRegistrationUseCaseToken = Symbol(
    "BalanceRegistrationUseCase",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.balanceRegistrationRepositoryToken,
      useClass: BalanceRegistrationImpl,
    },
    {
      scope: "otherRepo",
      token: this.balanceRegistrationUseCaseToken,
      useClass: BalanceRegistrationUseCase,
    },
    {
      scope: "viewModel",
      token: this.balanceRegistrationViewModelToken,
      useClass: BalanceRegistrationViewModel,
    },
  ];

  static getBalanceRegistrationRepo(): IBalanceRegistrationRepository {
    return this.resolve(this.balanceRegistrationRepositoryToken);
  }

  static getBalanceRegistrationUseCase(): BalanceRegistrationUseCase {
    return this.resolve(this.balanceRegistrationUseCaseToken);
  }
}
